// Central store to hold and manage state
import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: false,
  state: {
    currentUser: {},
    currentPackage: {},
    isAuthenticated: false,
    sports: [],
    packages: [],
    categories: [],
    products: [],
    currentProduct: null,
    cart: []
  },
  getters: getters,
  mutations: mutations,
  actions: actions
})



// WEBPACK FOOTER //
// ./src/store/store.js